/**
 * Use to add space between components when creating pages in amplience
 *
 * @module views/components/Spacer
 * @memberof -Common
 */
import './Spacer.scss';

import React from 'react';

import PropTypes from 'prop-types';
import { Spacer as PalSpacer } from 'web-palette/dist/components/Spacer/Spacer';

/**
 * Represents a Spacer component
 *
 * @method
 * @param {SpacerProps} props - React properties passed from composition
 * @returns Spacer
 */
export const Spacer = function( props ){
  const {
    value
  } = props;

  if( !value ){
    return null;
  }

  return (
    <PalSpacer
      spacerValue={ value }
    />
  );
};

/**
 * Property type definitions
 * @typedef SpacerProps
 * @type {object}
 * @property {string} value - Sets the spacing value
 */
export const propTypes =  {
  value: PropTypes.string
};

Spacer.propTypes = propTypes;
export default Spacer;